// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2816":"css/admin-app.6877","5725":"css/app.6877"}[chunkId] + ".css";
};